// sc-3040 follow-up — Sentinel values for the "Sperrvermerk" (Booker.nonDisclosureNotice)
// column filter. The same column accepts either a free-text search term or one of these
// two sentinels to filter for "field set" / "field empty". Shared between client (writes)
// and server (interprets) so the contract stays in lockstep.

export const NDN_FILTER_PRESENT = "__NDN_PRESENT__";
export const NDN_FILTER_ABSENT = "__NDN_ABSENT__";
